<template>
  <vx-card title="Bewerber" class="h-full">
    <div
      v-if="applicantsPage"
      class="vx-card__collapsible-content vs-con-loading__container"
    >
      <vs-table class="table-fixed w-full" :data="applicantsPage.results">
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Vorname</vs-th>
          <vs-th>Nachname</vs-th>
          <vs-th>Beworben am</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="applicant of data" :key="applicant.id">
            <vs-td>
              {{ applicant.number }}
            </vs-td>
            <vs-td>{{ applicant.firstName }} </vs-td>
            <vs-td>
              {{ applicant.lastName }}
            </vs-td>
            <vs-td> {{ $d(new Date(applicant.createdAt), "long") }} Uhr </vs-td>
            <vs-td>
              <router-link
                :to="{ name: 'applicant.edit', params: { id: applicant.id } }"
                ><i class="fal fa-arrow-right"></i
              ></router-link>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="text-right mx-3 mt-3">
        <router-link :to="{ name: 'applicant.overview' }" class="overview-link">
          Alle Bewerber <i class="fal fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
  </vx-card>
</template>

<script>
import gql from "graphql-tag";

export default {
  apollo: {
    applicantsPage: {
      query: gql`
        query ApplicantsPage($page: Int!, $size: Int) {
          applicantsPage(page: $page, size: $size) {
            total
            results {
              id
              number
              firstName
              lastName
              createdAt
            }
          }
        }
      `,
      variables() {
        return {
          page: 1,
          size: 10
        };
      }
    }
  }
};
</script>
